
ProgramIssues = [
    {name: 'program_model', label: 'Program Model'}
    {name: 'annual_survey', label: 'Annual Survey'}
    {name: 'amc_grant_report', label: 'AmC Grant Report'}
]

StudentIssues = [
    {name: 'demographics', label: 'Profile'}
    {name: 'followup', label: 'Followup'}
    {name: 'enrollment', label: 'Enrollment'}
    {name: 'education', label: 'Education'}
    {name: 'certificate', label: 'Certificates'}
    {name: 'amc', label: 'AmC Slots'}
    {name: 'placement', label: 'Placements'}
]

issueReportStates = ($stateProvider, TagUrl) ->
    'ngInject'

    url = new TagUrl()
        .addTagTypes(['program', 'location'])
        .setTagDefault('affiliation', 'all')
        .addExtraParam('page', {type: 'int', value: 1, squash: true})
        .addExtraParam('sort', 'name')

    programUrl = new TagUrl()
        .addTagTypes(['participant'])
        .setTagDefault('issues', 'yes')
        .addExtraParam('page', {type: 'int', value: 1, squash: true})
        .addExtraParam('sort', 'name')

    $stateProvider.state 'reports.issues',
        url: url.buildUrl('/issues')
        params: url.params
        data: tagUrl: url
        templateUrl: 'reports/issueReport'
        controller: 'IssueReportController'
        controllerAs: '$ctrl'
        reloadOnSearch: false
        resolve:
            program: () -> null
            link: () -> 'program.reports.issues'
            url: (ApiUrl) -> ApiUrl('reports', 'issues')
            columns: () -> ProgramIssues.concat(StudentIssues)


    $stateProvider.state 'program.reports.issues',
        url: programUrl.buildUrl('/issues')
        params: programUrl.params
        data: tagUrl: programUrl
        reloadOnSearch: false
        templateUrl: 'reports/issueReport'
        controller: 'IssueReportController'
        controllerAs: '$ctrl'
        resolve:
            url: (ApiUrl, program) -> ApiUrl('reports', 'issues', program.id)
            link: () -> 'student.overview'
            columns: () -> StudentIssues


class IssueReportController

    ### @ngInject ###
    constructor: ($http, $scope, $timeout, $stateParams, $state, url, columns, link, program) ->
        @http = $http
        @timeout = $timeout
        @state = $state
        @loading = true

        @program = program
        @url = url
        @link = link
        @columns = columns

        @sort = $stateParams.sort or 'name'
        @page = $stateParams.page or 1

        @noun = if @program then "Student" else 'Program'

        $scope.$watch '$ctrl.pager.page', @onPageChange

    triggerReload: () ->
        @timeout.cancel @timeoutPromise
        @timeoutPromise = @timeout @loadData, 100

    loadData: () =>
        @loading = true

        params = angular.extend {}, @tags,
            sort: @sort
            page: @page

        @state.go '.', params, location: 'replace'

        @http.get(@url, params: params).then (result) =>
            @loading = false
            @data = result.data.items
            @pager = result.data.pager
            @totals = result.data.totals

    onTagsChange: (tags) =>

        if not @tags
            @tags = tags
            @triggerReload()
            return

        if not angular.equals(tags, @tags)
            @tags = tags
            @onPageChange(1)
            @triggerReload()

    onSortChange: () ->
        @page = 1
        @triggerReload()

    onPageChange: (page) =>
        if not page or page == @page then return
        @page = page
        @triggerReload()


module.config issueReportStates
module.controller 'IssueReportController', IssueReportController
